import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import Text from '../components/atoms/Text'
import MainButton from '../components/atoms/MainButton'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getUserInfo } from '../api/home'
import { logEvent } from '../utils/eventLogger'

const Wrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 16px;
  word-break: keep-all;
`
const WelcomeMessage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
`
const GuideList = styled.ul`
  list-style: disc;
  padding-left: 20px;
  color: ${(props) => props.theme.colors.text.alternative};
  li {
    margin-bottom: 8px;
  }

  li:last-child {
    margin-bottom: 0;
  }
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; 
  padding: 0 20px;
`
const TextButton = styled.button`
  margin-top: 8px;
  background: none;
  border: none;
  cursor: pointer;
`
const VoiceRegisterIntro = () => {
  const [userInfo, setUserInfo] = useState({})
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async() => {
        try {
          const rlt = await getUserInfo();
          // console.log(rlt)
          setUserInfo(rlt)
          
        } catch (err) {
          // console.log(err)
          console.error(err);
        }
      }
      fetchUserInfo()
    }, [])
  
  // 아이 이름 뒤 조사 '이' 추가 함수
  const getPostfixI = (name) => {
    if (!name) return '';
    const lastChar = name[name.length - 1];
    const code = lastChar.charCodeAt(0) - 0xac00;
    return code % 28 !== 0 ? '이' : '';
  };

  const childName = `${userInfo.childName}${getPostfixI(userInfo.childName)}`

  return (
    <DefaultLayout>
      <Wrapper>
        <TextWrapper>
          <WelcomeMessage>
            <Text variant="headline2" weight="medium">{userInfo.userName}님 환영해요!</Text>
            <Text variant="headline2" weight="medium">{childName}와 함께 소통해봐요</Text>
          </WelcomeMessage>
          <Text weight="medium">AI 음성 인식 기능 사용을 위해 아이의 목소리를 먼저 등록해 주세요.</Text>
          <GuideList>
            <li>
              <Text variant="body2" color="alternative">음성 등록은 AI가 아이의 목소리를 학습하는 단계예요. 조용한 환경에서 진행해 주시면 더 정확해요.</Text>
            </li>
            <li>
              <Text variant="body2" color="alternative">원하시면 나중에 다시 진행하거나 재등록할 수도 있어요.</Text>
            </li>
          </GuideList>
        </TextWrapper>
        <ButtonWrapper>
          <MainButton
            $variant="secondary"
            title="목소리 등록하기"
            onClick={() =>{
              logEvent("voice_embedding_start")
              navigate('/signup/voice-register/record')
            }}
          />
          <TextButton
            onClick={() => navigate('/')}
          >
            <Text variant="body2">나중에 하기</Text>
          </TextButton> 
        </ButtonWrapper>
      </Wrapper>
  
    </DefaultLayout>
  )
}

export default VoiceRegisterIntro
